(function() {
    window.apos = window.apos || {};
    var data = document.body && document.body.getAttribute('data-apos');
    Object.assign(window.apos, JSON.parse(data || '{}'));
    if (data) {
      document.body.removeAttribute('data-apos');
    }
    if (window.apos.modules) {
      for (const module of Object.values(window.apos.modules)) {
        if (module.alias) {
          window.apos[module.alias] = module;
        }
      }
    }
})();import index_0App from "file:///home/mklive-gui/www/node_modules/apostrophe/modules/@apostrophecms/util/ui/src/index.js";


import index_1App from "file:///home/mklive-gui/www/node_modules/apostrophe/modules/@apostrophecms/i18n/ui/src/index.js";


import index_2App from "file:///home/mklive-gui/www/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/src/index.js";


import index_3App from "file:///home/mklive-gui/www/node_modules/apostrophe/modules/@apostrophecms/video-widget/ui/src/index.js";


import index_4App from "file:///home/mklive-gui/www/modules/asset/ui/src/index.js";



import "file:///home/mklive-gui/www/node_modules/apostrophe/modules/@apostrophecms/styles/ui/src/index.scss";


import "file:///home/mklive-gui/www/node_modules/apostrophe/modules/@apostrophecms/ui/ui/src/index.scss";


import "file:///home/mklive-gui/www/node_modules/apostrophe/modules/@apostrophecms/image-widget/ui/src/index.scss";


import "file:///home/mklive-gui/www/modules/asset/ui/src/index.scss";index_0App();
index_1App();
index_2App();
index_3App();
index_4App();